import React, { useEffect, useState } from 'react';
import { Button, Divider, LinearProgress, Paper, Typography } from '@material-ui/core';
import DataGrid from '../../../components/ui/Table'
import { getTags } from '../../../business/actions/tags'
import { Link } from 'react-router-dom';
import { useAuth } from '../../../business/authProvider';
import PageHeading from '../../../components/ui/PageHeading';
const columns = [
  { field: 'text', headerName: 'Tag' },
];


export default function DataTable() {
  const auth = useAuth();
  const paginationLimit = parseInt(localStorage.getItem("rows") || 5, 10);
  
  const [busy, setBusy] = useState(false)
  const [data, setData] = useState([])
  const [totalItems, setTotalItems] = useState(0);
  const [pagination, setPagination] = useState({ offset: 0, limit: paginationLimit })

  const authRoles= auth.roles;
  useEffect(() => {
    setBusy(true)
    getTags({}).then(json => {
      //let { TotalItems, PaginatedItems } = json;
      setTotalItems(json.length);
      setData(json.sort((a, b) => b.created_at - a.created_at))
    }).finally(e => setBusy(false))
  }, []);
  return (
    <div style={{ height: 400, width: '100%' }}>
      <Paper>
        <PageHeading title={'Tags'}>
          {(auth.permission || authRoles['post_tag']) ?
            <Button component={Link} to={'/tags/create'} variant="contained" color="primary">
              Add New Tag
            </Button>
            : null
          }
        </PageHeading>
        <Divider />
        {busy ? <LinearProgress /> : null}
        <div style={{ padding: 16 }}>
          <DataGrid
            idField={'id'}
            route={'tags'}
            canEdit={(auth.permission || authRoles['post_tag_tag_id'])}
            canDelete={false}
            canSort={false}
            extraColumns={false}
            rows={data?.slice(pagination.offset, pagination.offset + pagination.limit) || []}
            columns={columns}
            count={totalItems}
            pagination={pagination}
            onUpdatePagination={setPagination}
            checkboxSelection />
        </div>
      </Paper>
    </div>
  );
}